import { EditorObject } from 'utils/responsiveTypes'

const minimalListsSingleColumn: EditorObject = {
  x: 0,
  y: 361,
  id: '2bv3mrgo65nwqhk79176zvubu',
  name: 'Section 20',
  type: 'LAYOUT_SECTION',
  width: 1512,
  height: 298,
  hidden: false,
  mobile: {
    x: 0,
    y: 20,
    width: 1512,
    height: 432,
    pushGraph: {
      edges: [],
      nodeIds: ['7q4f2vckh6l630xekefsp7js8'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  shadow: {
    x: 0,
    y: 2,
    size: 4,
    color: '#00000020',
    enabled: true,
  },
  shared: {
    mobile: false,
    tablet: false,
    desktop: false,
  },
  tablet: {
    x: 0,
    y: 20,
    width: 1512,
    height: 429,
    pushGraph: {
      edges: [],
      nodeIds: ['7q4f2vckh6l630xekefsp7js8'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  actions: {},
  desktop: {
    x: 0,
    y: 20,
    width: 1512,
    height: 424,
    pushGraph: {
      edges: [],
      nodeIds: ['7q4f2vckh6l630xekefsp7js8'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  opacity: 1,
  children: [
    {
      x: 0,
      y: 376,
      id: '7q4f2vckh6l630xekefsp7js8',
      name: 'Layout Helper',
      type: 'section',
      width: 1512,
      height: 268,
      hidden: false,
      mobile: {
        x: 0,
        y: 35,
        width: 1512,
        height: 402,
        pushGraph: {
          edges: [],
          nodeIds: ['1uawhmq8i0j2jbicshf62htz7'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      shadow: {
        x: 0,
        y: 2,
        size: 4,
        color: 'rgba(0, 0, 0, 0.2)',
        enabled: false,
      },
      shared: {
        mobile: false,
        tablet: false,
        desktop: false,
      },
      tablet: {
        x: 0,
        y: 35,
        width: 1512,
        height: 399,
        pushGraph: {
          edges: [],
          nodeIds: ['1uawhmq8i0j2jbicshf62htz7'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      actions: {},
      desktop: {
        x: 0,
        y: 35,
        width: 1512,
        height: 394,
        pushGraph: {
          edges: [],
          nodeIds: ['1uawhmq8i0j2jbicshf62htz7'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      opacity: 1,
      purpose: 'layout_helper',
      children: [
        {
          x: 16,
          y: 376,
          id: '1uawhmq8i0j2jbicshf62htz7',
          name: 'Container',
          type: 'section',
          width: 1480,
          height: 268,
          hidden: false,
          mobile: {
            x: 62.030769230769344,
            y: 35,
            width: 1387.9384615384615,
            height: 402,
            pushGraph: {
              edges: [],
              nodeIds: ['bgkjg876zx0nzj7atuqziqyp5'],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          shadow: {
            x: 0,
            y: 2,
            size: 4,
            color: '#00000020',
            enabled: true,
          },
          shared: {
            mobile: false,
            tablet: false,
            desktop: false,
          },
          tablet: {
            x: 192.67266187050353,
            y: 35,
            width: 1127.6546762589928,
            height: 399,
            pushGraph: {
              edges: [],
              nodeIds: ['bgkjg876zx0nzj7atuqziqyp5'],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          actions: {},
          desktop: {
            x: 261.99999999999994,
            y: 35,
            width: 989.9999999999999,
            height: 394,
            pushGraph: {
              edges: [],
              nodeIds: ['bgkjg876zx0nzj7atuqziqyp5'],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          opacity: 1,
          purpose: 'container',
          children: [
            {
              x: 73.87709497206693,
              y: 393,
              id: 'bgkjg876zx0nzj7atuqziqyp5',
              name: 'List 24',
              type: 'list',
              width: 1380.782122905027,
              height: 289,
              hidden: false,
              mobile: {
                x: 77.53846153846166,
                y: 52,
                width: 1372.430769230769,
                height: 346,
                pushGraph: {
                  edges: [
                    {
                      distance: 4,
                      endNodeId: '1cxh6xe413nx5l0scglm1fbr3',
                      startNodeId: 'buffer_1cxh6xe413nx5l0scglm1fbr3',
                    },
                    {
                      distance: 4,
                      endNodeId: '2zkp82q2tp2eb1du97u89h16v',
                      startNodeId: '1cxh6xe413nx5l0scglm1fbr3',
                    },
                  ],
                  nodeIds: [
                    '2vic7hchalkofvtjr7cwlm729',
                    'buffer_1cxh6xe413nx5l0scglm1fbr3',
                    '1cxh6xe413nx5l0scglm1fbr3',
                    '2zkp82q2tp2eb1du97u89h16v',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shared: {
                mobile: false,
                tablet: false,
                desktop: false,
              },
              tablet: {
                x: 201.38714932227322,
                y: 52,
                width: 1110.2257013554533,
                height: 367,
                pushGraph: {
                  edges: [
                    {
                      distance: 20,
                      endNodeId: '1cxh6xe413nx5l0scglm1fbr3',
                      startNodeId: 'buffer_1cxh6xe413nx5l0scglm1fbr3',
                    },
                    {
                      distance: 5,
                      endNodeId: '2zkp82q2tp2eb1du97u89h16v',
                      startNodeId: '1cxh6xe413nx5l0scglm1fbr3',
                    },
                  ],
                  nodeIds: [
                    '2vic7hchalkofvtjr7cwlm729',
                    'buffer_1cxh6xe413nx5l0scglm1fbr3',
                    '1cxh6xe413nx5l0scglm1fbr3',
                    '2zkp82q2tp2eb1du97u89h16v',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              actions: {},
              desktop: {
                x: 272.8990825688073,
                y: 52,
                width: 968.2018348623856,
                height: 369,
                pushGraph: {
                  edges: [
                    {
                      distance: 27.125,
                      endNodeId: '1cxh6xe413nx5l0scglm1fbr3',
                      startNodeId: 'buffer_1cxh6xe413nx5l0scglm1fbr3',
                    },
                    {
                      distance: 5.75,
                      endNodeId: '2zkp82q2tp2eb1du97u89h16v',
                      startNodeId: '1cxh6xe413nx5l0scglm1fbr3',
                    },
                  ],
                  nodeIds: [
                    '2vic7hchalkofvtjr7cwlm729',
                    'buffer_1cxh6xe413nx5l0scglm1fbr3',
                    '1cxh6xe413nx5l0scglm1fbr3',
                    '2zkp82q2tp2eb1du97u89h16v',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              masonry: true,
              opacity: 1,
              children: [
                {
                  x: 73.87709497206693,
                  y: 393,
                  id: '2vic7hchalkofvtjr7cwlm729',
                  name: 'Image 30',
                  type: 'image',
                  width: 525.0279329608936,
                  height: 91,
                  hidden: false,
                  mobile: {
                    x: 77.53846153846166,
                    y: 52,
                    width: 523.3846153846154,
                    height: 105,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 201.38714932227322,
                    y: 52,
                    width: 421.6614784945964,
                    height: 106,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 272.8990825688073,
                    y: 52,
                    width: 182.23111458130018,
                    height: 107,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  imageURL: '',
                  imageType: 'uploaded',
                  pushGraph: {
                    edges: [],
                    nodeIds: [],
                  },
                  filename1x: {
                    url: '73d1ddbe9659b3c2038103939f80606ddf04a48c7e77af3f43377a56d7bc0d85.jpg',
                    filename: 'gradient.jpg',
                  },
                  borderColor: '#999',
                  borderStyle: 'none',
                  borderWidth: 1,
                  imageResize: 'cover',
                  positioning: 'fixed',
                  borderRadius: 8,
                  imageBinding: null,
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'mobile',
                  backgroundColor: '#ddd',
                  backgroundStyle: 'none',
                },
                {
                  x: 644.3798882681525,
                  y: 412,
                  id: '1cxh6xe413nx5l0scglm1fbr3',
                  name: null,
                  text: 'Item Title',
                  type: 'label',
                  color: '@text',
                  width: 810.2793296089352,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 644.5906955320121,
                    y: 56,
                    width: 805.378535237218,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 650.1248105871138,
                    y: 72,
                    width: 661.1124435882442,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 472.56099941441244,
                    y: 79.125,
                    width: 768.5399180167874,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: true,
                  fontFamily: '@body',
                  // fontWeight: '700',
                  layoutText: ['Item Title'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'mobile',
                  textAlignment: 'left',
                },
                {
                  x: 631.977653631284,
                  y: 427,
                  id: '2zkp82q2tp2eb1du97u89h16v',
                  name: null,
                  text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vestibulum posuere ornare. Quisque varius magna nunc, ut vulputate lacus tempus nec. ',
                  type: 'label',
                  color: 'rgba(117, 117, 117, 1)',
                  width: 810.2793296089308,
                  height: 28,
                  hidden: false,
                  mobile: {
                    x: 643.5692307692307,
                    y: 79,
                    width: 806.3999999999999,
                    height: 28,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 650.1310705288189,
                    y: 96,
                    width: 651.5096930109861,
                    height: 28,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 472.71559633027533,
                    y: 103.875,
                    width: 746.5871559633028,
                    height: 28,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 12,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: true,
                  fontFamily: '@body',
                  // fontWeight: 'normal',
                  layoutText: [
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vestibulum posuere ornare. Quisque varius magna nunc, ut vulputate lacus tempus',
                    'nec. ',
                  ],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    '-apple-system, "SF Pro Text", sans-serif',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 19,
                    endNodeId: '1cxh6xe413nx5l0scglm1fbr3',
                    startNodeId: 'buffer_1cxh6xe413nx5l0scglm1fbr3',
                  },
                  {
                    distance: 34,
                    endNodeId: '2zkp82q2tp2eb1du97u89h16v',
                    startNodeId: 'buffer_2zkp82q2tp2eb1du97u89h16v',
                  },
                ],
                nodeIds: [
                  '2vic7hchalkofvtjr7cwlm729',
                  'buffer_1cxh6xe413nx5l0scglm1fbr3',
                  '1cxh6xe413nx5l0scglm1fbr3',
                  'buffer_2zkp82q2tp2eb1du97u89h16v',
                  '2zkp82q2tp2eb1du97u89h16v',
                ],
              },
              rowMargin: 20,
              columnCount: 1,
              positioning: null,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'mobile',
              backgroundColor: 'rgba(0, 0, 0, 0)',
            },
          ],
          pushGraph: {
            edges: [],
            nodeIds: ['bgkjg876zx0nzj7atuqziqyp5'],
          },
          borderColor: '#e0e0e0',
          borderStyle: 'none',
          borderWidth: 1,
          positioning: 'fixed',
          borderRadius: 10,
          responsivity: {
            verticalScaling: 'FIXED',
            horizontalScaling: 'SCALES_WITH_PARENT',
            verticalPositioning: 'TOP',
            horizontalPositioning: 'LEFT_AND_RIGHT',
          },
          initialDevice: 'mobile',
          borderPosition: 'center',
          backgroundColor: '#f5f5f5',
          backgroundStyle: 'none',
        },
      ],
      pushGraph: {
        edges: [],
        nodeIds: ['1uawhmq8i0j2jbicshf62htz7'],
      },
      borderColor: '#BDBDBD',
      borderStyle: 'none',
      borderWidth: 1,
      positioning: 'fixed',
      borderRadius: 0,
      responsivity: {
        verticalScaling: 'FIXED',
        horizontalScaling: 'SCALES_WITH_PARENT',
        verticalPositioning: 'TOP',
        horizontalPositioning: 'CENTER',
      },
      initialDevice: 'mobile',
      borderPosition: 'center',
      backgroundColor: '#e0e0e0',
      backgroundStyle: 'none',
    },
  ],
  pushGraph: {
    edges: [],
    nodeIds: ['7q4f2vckh6l630xekefsp7js8'],
  },
  borderColor: '#e0e0e0',
  borderStyle: 'none',
  borderWidth: 1,
  imageResize: 'cover',
  positioning: 'fixed',
  borderRadius: 0,
  responsivity: {
    verticalScaling: 'FIXED',
    horizontalScaling: 'SCALES_WITH_PARENT',
    verticalPositioning: 'TOP',
    horizontalPositioning: 'CENTER',
  },
  initialDevice: 'desktop',
  snappingRules: {
    lock: {
      left: 0,
      right: 0,
    },
    snap: true,
    snapType: 'screenEdge',
  },
  borderPosition: 'center',
  backgroundColor: '@background',
  backgroundStyle: 'none',
}

export default minimalListsSingleColumn
